import styled, { css } from 'styled-components';
import { styleReset } from '../../styles/misc';
import { mq } from '../../styles/mq';
import { theme } from '../../styles/theme';
import { Container } from '../../components/container';
import { LogoUA } from './logo';

export const StyledHeader = styled.header<{ $isHeaderOpen: boolean }>`
  position: sticky;
  position: fixed;
  ${(props) => (props.$isHeaderOpen ? 'top: 0' : 'top: -6.1rem')};
  ${mq.smallOnly} {
    ${(props) => (props.$isHeaderOpen ? 'top: 0' : 'top: -5.1rem')};
  }
  transition: top 0.5s;
  width: 100%;
  padding: 1rem;
  height: 6rem;
  font-size: 1.6rem;
  z-index: 10000;
  ${mq.smallOnly} {
    height: 5rem;
  }

  .header-background {
    position: absolute;
    background-color: ${theme.colors.background};
    top: 0;
    left: 0;
    height: 6rem;
    width: 100%;
    ${mq.smallOnly} {
      height: 5rem;
    }
  }
`;
export const HeaderContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  padding: 1rem;
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid ${theme.colors.text};
  > ${Container} {
    display: flex;
    align-items: center;
  }
  div {
    display: flex;
    align-items: center;
  }
`;
export const LogoContainer = styled.a`
  position: relative;
  transition: all 0.3s;
  color: inherit;

  &:hover,
  &:focus {
    color: inherit;
  }
`;
export const Logo = styled(LogoUA)`
  height: 4rem;
  width: auto;
  display: block;

  ${mq.smallOnly} {
    height: 3rem;
  }
`;

export const CloseButton = styled.li`
  margin-top: -0.1em;
  padding: 0.8rem;

  button {
    ${styleReset}
    display: block;
    position: relative;
    cursor: pointer;
    width: 1.6rem;
    height: 1.6rem;
    background: none;
    border: none;

    &::before,
    &::after {
      content: '';
      display: block;
      position: absolute;
      top: 50%;
      left: 0;
      width: 100%;
      border-top: 2px solid white;
      transform: rotateZ(45deg);
    }

    &::after {
      transform: rotateZ(-45deg);
    }
  }

  ${mq.smallOnly} {
    button::before,
    button::after {
    }
  }
`;

export const LanguageButton = styled.div<{ $isOpen: boolean }>`
  position: relative;
  transition: 0.3s opacity 0.55s;
  ${(props) =>
    props.$isOpen
      ? css`
          opacity: 0;
          transition-delay: 0s;
        `
      : css``}
  height: 20px;
  color: ${theme.colors.text};
  border-right: 1px solid ${theme.colors.text};
  font-weight: 400;
  padding: 0 1rem;
  a {
    color: ${theme.colors.text};
    text-decoration: none;
    font-size: 1.6rem;
    ${mq.smallOnly} {
      font-size: 1.5rem;
    }
  }
  .active {
    padding-top: 3px;
    &:hover {
      opacity: 0.8;
      cursor: pointer;
    }
  }
  .passive {
    font-weight: 800;
  }
`;
